<template>
  <v-card
    elevation="0"
    class="rounded-lg pa-0 w-100 h-100"
    style="overflow-y: auto"
  >
    <v-card-title class="px-lg-3 py-lg-2 d-flex justify-space-between">
      <h6 class="text-caption mr-1 font-weight-bold">
        {{ $helper.isCompanyHasItems() ? "Order Item" : "Order" }} info
      </h6>

      <SecondaryButton
        id="ordersShowMore"
        x-small
        v-if="$helper.isCompanyHasItems()"
        btnClass="text-uppercase"
        depressed
        name="Show More"
        @click="$emit('orderItemList')"
      >
      </SecondaryButton>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-subtitle>
      <v-row no-gutters>
        <v-col cols="6" class="d-flex mb-4" v-if="dataObj.total_quantity">
          <BoxIconWithText
            icon="mdi-filter"
            title="Total quantity"
            :text="dataObj.total_quantity"
          />
        </v-col>
        <v-col
          cols="6"
          class="d-flex mb-4"
          v-if="dataObj.total_items && $helper.isCompanyHasItems()"
        >
          <BoxIconWithText
            icon="mdi-archive"
            :title="`Total ${itemModule.itemPlural}`"
            :text="dataObj.total_items"
          />
        </v-col>
        <v-col cols="6" class="d-flex mb-4" v-if="dataObj.volume">
          <BoxIconWithText
            icon="mdi-cube"
            :title="`Total Volume`"
            :text="dataObj.volume"
          />
        </v-col>
        <v-col cols="6" class="d-flex mb-4" v-if="dataObj.weight">
          <BoxIconWithText
            icon="mdi-weight"
            :title="`Total weight`"
            :text="dataObj.weight"
          />
        </v-col>
      </v-row>
    </v-card-subtitle>
  </v-card>
</template>

<script>
import {
  configurationModule,
  customerModule,
  orderModule,
  tripModule,
  fleetModule,
  itemModule,
} from "@/utils/moduleMapping";
import BoxIconWithText from "@/components/BaseComponents/BoxIconWithText.vue";
export default {
  components: {
    BoxIconWithText,
  },
  props: {
    dataObj: {
      required: true,
    },
  },
  data() {
    return {
      itemModule,
    };
  },
};
</script>